import { render, staticRenderFns } from "./MyAccounts.vue?vue&type=template&id=ec94f038"
import script from "./MyAccounts.vue?vue&type=script&lang=ts"
export * from "./MyAccounts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports